var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 50,
    fill: "#363a3c",
    r: 6.39718
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.875s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.678,
    cy: 67.678,
    fill: "#363a3c",
    r: 4.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.75s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    fill: "#363a3c",
    r: 4.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.625s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.322,
    cy: 67.678,
    fill: "#363a3c",
    r: 4.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 50,
    fill: "#363a3c",
    r: 4.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.375s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.322,
    cy: 32.322,
    fill: "#363a3c",
    r: 4.80282
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.25s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    fill: "#363a3c",
    r: 6.40282
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.125s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.678,
    cy: 32.322,
    fill: "#363a3c",
    r: 7.99718
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.8;4.8;8;4.8;4.8",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b9c5c953be7859837b45e1c93ed1571a.svg";
export { ForwardRef as ReactComponent };